<template>
    <div class="container">
        <div class="card_content">
            <div v-for="(item, index) in menuList" :key="index">
                <van-row class="row" :class="{ 'pop-animate': poppingIndex === index }"
                    @click="onMenuClick(item.path, index)" v-if="checkMenuShow(index)">
                    <van-col span="2" class="icon_image">
                        <img :src="item.img" alt="">
                    </van-col>
                    <van-col span="19" offset="1" class="row_text">
                        <div>{{ $t(item.name) }}</div>
                        <div v-if="item.msg" class="sub_text">{{ $t(item.msg) }}</div>
                    </van-col>
                    <van-col span="2" class="icon">
                        <img src="@/assets/profile/arrow_right_white45.png" alt="">
                    </van-col>
                </van-row>
            </div>

        </div>
    </div>
    <ContactServicePopup ref="contactServiceRef" />

</template>

<script setup lang="ts">
import { ref, defineEmits } from 'vue'
import { useRouter } from 'vue-router';
import { inject } from 'vue'
import { clickOnMenu, MENU_LIST } from '@/view/profile/supportScript';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { useActivityStore } from '@/stores/activity';
const activityStore = useActivityStore()
const router = useRouter();
const menuList = ref(MENU_LIST)
const emits = defineEmits(['logout'])
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)

const openLogoutPopup = inject<() => void>('openLogoutPopup')

const handleLogoutClick = () => {
    openLogoutPopup?.()
}
const checkMenuShow = (index: number) => {
    if (index === 2) {
        const isAvailableRedeem = activityStore.activityList.some((obj:any) => obj.name === "redeem_code")
        if (isAvailableRedeem) {
            return true
        } else {
            return false
        }
    }

    return true
}
const onMenuClick = (path: string | null, index: number) => {
    clickOnMenu(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
}

</script>
<style scoped>
.container {
    padding: 0px 15px;
    margin: 10px 0;
}

.card_content {
    padding: 0 15px 15px;
    border-radius: 10px;
    background-image: radial-gradient(circle at 0% 0%, rgba(123, 89, 54, 0.75) 0%, rgba(123, 89, 54, 0.0) 30%), radial-gradient(circle at 89% 100%, rgba(110, 80, 50, 0.75) 0%, rgba(110, 80, 50, 0.00) 18%), linear-gradient(74deg, #3A2B1E 0%, #3B2C1F 100%);
}

.icon_image img {
    width: 25px;
}

.icon img {
    width: 15px
}

.icon {
    display: flex;
    align-items: center;
    justify-content: right;
}

.row_text {
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
}

.row {
    padding: 15px 0 0;
}

.sub_text {
    font-size: 10px;
    text-align: right;
    width: 100%;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}
</style>